const Index = () =>
  import(/* webpackChunkName: "profile" */ './index.vue');
const List = () =>
  import(/* webpackChunkName: "profile" */ './components/List.vue');
const Create = () =>
  import(/* webpackChunkName: "profile" */ './components/Create.vue');
const Edit = () =>
  import(/* webpackChunkName: "profile" */ './components/Edit.vue');
const ProfileView = () =>
  import(/* webpackChunkName: "profile" */ './components/ProfileView.vue');

const PublicProfile = () =>
  import(/* webpackChunkName: "profile" */ './components/PublicProfile.vue');


export default [
  {
    path: 'profile',
    name: 'profile',
    component: Index,
    title: 'Profile',
    redirect: { name: 'profile-list' },
    children: [
      {
        path: 'list',
        name: 'profile-list',
        component: List,
      },
      {
        path: 'create',
        name: 'profile-create',
        component: Create,
      },
      {
        path: 'edit',
        name: 'profile-edit',
        component: Edit,
        props: (route) => ({
          profileId: route.params.profileId || null,
        }),
        meta: { requiresAuth: true },
      },
      {
        path: 'view',
        name: 'profile-view',
        component: ProfileView,
        props: (route) => ({
          profileId: route.params.profileId || null,
        }),
        meta: {
          requiresAuth: true,
        },
      },
      // {
      //   path: 'open',
      //   name: 'public-profile-view',
      //   component: PublicProfile,
      //   props: (route) => ({
      //     profileId: route.params.profileId || route.state?.profileId || null,
      //     isView: route.query.view === 'true' || false,
      //   }),
      //   meta: {
      //     requiresAuth: true,
      //   },
      // },
      {
        path: 'open/:profileId',
        name: 'public-profile-view',
        component: PublicProfile,
        props: (route) => ({
          profileId: route.params.profileId || null,
          isView: route.query.view === 'true' || false,
        }),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "favorites",
        name: "favorites",
        component: () => import("@/modules/Profile/components/FavoritesList.vue"),
        meta: { requiresAuth: true },
      }
    ],
  },
];